import { useMemo, useState, useCallback } from "react";
import { openInvoice } from '@telegram-apps/sdk';
import { PaymentApi } from "../api/paymentApi";
import { updateBalance } from "../../app/store/slices/userSlice.ts";
import { useAppDispatch } from "../../app/store/hooks.ts";
import { UserApi } from "../api/userApi.ts";
import { setPaymentOpen } from "../../app/store/slices/appSlice.ts";
import { PaymentProviderEnum } from "../../shared/types/PaymentProviderEnum.ts";




export const useMakePayment = () => {
    const dispatch = useAppDispatch();
    const paymentApi = useMemo(() => new PaymentApi(), []);
    const userApi = useMemo(() => new UserApi(), []);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const makePayment = useCallback(async (paymentPackId: string, paymentProvider: PaymentProviderEnum) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await paymentApi.makePayment(paymentPackId, paymentProvider);


           await openInvoice(response.invoiceLink, 'url');

            if (status === 'paid') {
                try {
                    const { balance } = await userApi.getUserBalance();

                    dispatch(updateBalance(balance));
                    dispatch(setPaymentOpen(false));

                } catch (err) {
                    setError('Failed to update balance');
                }

            } else if (status === 'cancelled') {
                dispatch(setPaymentOpen(false));

            } else if (status === 'failed') {
                setError('Payment failed');
                dispatch(setPaymentOpen(false));

            } else if (status === 'pending') {
                dispatch(setPaymentOpen(false));
            }

            setIsLoading(false);

        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Payment failed';
            setError(errorMessage);
            setIsLoading(false);

            return { success: false, error: errorMessage };
        }
    }, [paymentApi, userApi, dispatch]);

    return { makePayment, isLoading, error };
};
